import Loading from "@/components-legacy/loading";

export default function AuthLoading() {
  return <Loading />;
}
